export const tokens = {
    list: {
        gap: 6,
    },
    action: {
        gap: 6,
        height: {
            mobile: 40,
            desktop: 28,
        },
    },
    label: {
        size: {
            mobile: 14,
            desktop: 11,
        },
    },
    icon: {
        size: 14,
    },
};
